import React from 'react';
import { addDays, addYears, startOfTomorrow } from 'date-fns';
import { Datepicker } from '@ag1/ui';
import clsx from 'clsx';
import styles from './SelectDatepicker.module.scss';
import { SelectDatepickerV2Props } from '../../SelectOrderDateV2.types';

export const SelectDatepickerV2 = ({
  value,
  defaultValue,
  onChange,
  nextOrderDate,
  className
}: SelectDatepickerV2Props) => {
  if (!nextOrderDate) {
    return null;
  }

  return (
    <div className={clsx(styles.datepicker, className)}>
      <Datepicker
        weekStartsOn={1}
        defaultMonth={defaultValue}
        mode="single"
        selected={value}
        onSelect={onChange}
        disabled={[
          value || false,
          { before: startOfTomorrow(), after: addYears(addDays(nextOrderDate, -1), 1) }
        ]}
      />
    </div>
  );
};
